const Logo = () => {
	return (
		<img
			src={require('./images/ladybug-logo.png')}
			alt="ladybug-logo"
			className="ladybug-logo"
		/>
	)
}

export default Logo
